import * as React from "react";
import Accordion, { accordionClasses } from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails, {
  accordionDetailsClasses,
} from "@mui/material/AccordionDetails";
import Typography from "@mui/material/Typography";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import Fade from "@mui/material/Fade";

export default function FAQsBox() {
  const [expanded, setExpanded] = React.useState(false);

  const handleExpansion = () => {
    setExpanded((prevExpanded) => !prevExpanded);
  };

  return (
    <div>
      <Accordion
        expanded={expanded}
        onChange={handleExpansion}
        slots={{ transition: Fade }}
        slotProps={{ transition: { timeout: 400 } }}
        sx={[
          expanded
            ? {
                [`& .${accordionClasses.region}`]: {
                  height: "auto",
                },
                [`& .${accordionDetailsClasses.root}`]: {
                  display: "block",
                },
              }
            : {
                [`& .${accordionClasses.region}`]: {
                  height: 0,
                },
                [`& .${accordionDetailsClasses.root}`]: {
                  display: "none",
                },
              },
        ]}
      >
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel1-content"
          id="panel1-header"
        >
          <Typography component="span">
            What kinds of questions can I ask?
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography>
            You can ask about anything related to your legal situation, such as
            questions about a specific process, documents or forms related to
            your legal matter, or about the meaning of specific terms or
            phrases. You can ask for advice, strategic coaching, or insight into
            possible outcomes. Advice sessions and document review services are
            also a good way to get a second opinion about your legal issue.
          </Typography>
        </AccordionDetails>
      </Accordion>
      <Accordion>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel2-content"
          id="panel2-header"
        >
          <Typography component="span">
            How can I keep my identity private while asking questions?
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography>
            Your query and lawyer responses will be published on our website,
            without your details. We do NOT publish your name or contact
            details. Lawyers who answer your query may contact you to discuss
            your query in detail.
          </Typography>
        </AccordionDetails>
      </Accordion>
      <Accordion>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel3-content"
          id="panel3-header"
        >
          <Typography component="span">
            When can I expect a reply to my question?
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography>
            Lawyers on LawRato have different and unique expertise. We work to
            serve your question to the right lawyer for a quick and useful
            response. You can expect to get a response in 24 working hours after
            posting your question. Lawyers on LawRato are active and are
            passionate about helping you solve your legal problems, meaning you
            won’t have to wait very long to get answers.
          </Typography>
        </AccordionDetails>
      </Accordion>
      <Accordion>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel4-content"
          id="panel4-header"
        >
          <Typography component="span">
            How can I find if my question was answered?
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography>
            We will notify you by Email and SMS whenever your question receives
            an answer. If at any time you wish to see the question you have
            posted, you can view My Questions tab in your account.
          </Typography>
        </AccordionDetails>
      </Accordion>
    </div>
  );
}
